<div class="banner">
  <p class="banner-title">{{ title }}</p>
  <p class="banner-text">
    {{ text }}
  </p>
  <div class="banner-link-group">
    <a class="banner-link-text" [routerLink]="link"
      >{{ linkText }}
      <div class="banner-link-icon-wrapper">
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12.9997H16.17L11.29 17.8797C10.9 18.2697 10.9 18.9097 11.29 19.2997C11.68 19.6897 12.31 19.6897 12.7 19.2997L19.29 12.7097C19.68 12.3197 19.68 11.6897 19.29 11.2997L12.71 4.69973C12.32 4.30973 11.69 4.30973 11.3 4.69973C10.91 5.08973 10.91 5.71973 11.3 6.10973L16.17 10.9997H5C4.45 10.9997 4 11.4497 4 11.9997C4 12.5497 4.45 12.9997 5 12.9997Z"
          />
        </svg>
      </div>
    </a>
  </div>
</div>
